var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowsActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.625 3.277 9.429-1.284.004 9.094-9.424.054-.009-7.864zm9.424 8.858.008 9.103-9.425-1.296v-7.868l9.417.061zm1.143-10.31L23.694 0v10.972l-12.502.099V1.825zM23.697 12.22l-.003 10.922-12.502-1.764-.017-9.179 12.522.02z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.625)",
    d: "M0 0h23.25v23.25H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsActive);
export default __webpack_public_path__ + "static/media/windows-active.d6225d21afb11a6c1dc0c671435fd4d5.svg";
export { ForwardRef as ReactComponent };